import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import Modal, {modalSizes} from '../../../components/layout/modal.jsx';

class PrintOutScreenshot extends React.Component {
  static displayName = 'EmailScreenshot';

  static propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  };

  state = {
    open: false,
  };

  open = (e) => {
    e.preventDefault();

    this.setState({open: true});
  };

  close = () => {
    this.setState({open: false});
  };

  render() {
    let imageURL = `/Content/img/printout-options/screenshots/${!!this.props.value ? 'parameters' : 'scales'}.png`;

    return <div style={{display: 'inline-block'}}>
      <a onClick={this.open} href={imageURL}><FormattedMessage id="general.view" /></a>
      {this.state.open ? <Modal onClose={this.close} size={modalSizes.large}>
        <div>
          <h2 className='with-keyline'>{this.props.title}</h2>
          <img src={imageURL} style={{width: '90%', marginLeft: '5%', marginRight: '5%'}} />
        </div>
      </Modal> : null}
    </div>;
  }
}

export default PrintOutScreenshot;
